// extracted by mini-css-extract-plugin
module.exports = {"input":"styles_input__jVpY6","labelColumn1":"styles_labelColumn1__KOFxu","labelColumn2":"styles_labelColumn2__gYJZk","labelWrapper":"styles_labelWrapper__H2rDY"};